import React from 'react'
import { storiesOf } from '@storybook/react'

import Grid from '@material-ui/core/Grid'
import LabeledValue from 'components/LabeledValue'

storiesOf('LabeledValue', module)
  .add('with string values', () => (
    <LabeledValue label="Label" value="Value" />
  ))
  .add('in a grid', () => (
    <Grid container direction="row">
      <Grid item xs>
        <LabeledValue label="Prize" value="k1000" />
      </Grid>
      <Grid item xs>
        <LabeledValue label="Prize" value="k1000" />
      </Grid>
      <Grid item xs>
        <LabeledValue label="Prize" value="k1000" />
      </Grid>
    </Grid>
  ))
